module.exports = "<div class=\"action-buttons center\">\n  <my-floating-button ng-repeat=\"button in buttons\"\n    enable-large=\"true\"\n    my-icon=\"button.icon\"\n    my-style=\"button.class(myData) + ' btn-space'\"\n    my-click=\"button.action(myData, true)\"\n    ng-show=\"button.display('action')\">\n  </my-floating-button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/buttons/myActionButtons.html
// module id = 1204
// module chunks = 0